import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Form, Input, Button, Card, Select, DatePicker, Alert, Modal } from "antd";
import { obtenerUsuario, actualizarUsuario } from '../api/participantesApi';
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const obtenerMensaje = (respuesta, mensajePredeterminado) => {
  const mensajes = [respuesta?.error, respuesta?.message, respuesta?.mensaje];
  return mensajes.find((texto) => typeof texto === "string" && texto.trim())
    || mensajePredeterminado;
};

const EditarUsuario = () => {
  const { id } = useParams(); // obtenemos el id
  const { Option } = Select;
  const [guardando, setGuardando] = useState(false);
  const [errorGuardar, setErrorGuardar] = useState("");
  const [modal, contextHolder] = Modal.useModal();
  const [usuario, setUsuario] = useState({
    id:"",
    nombre: "",
    apellidos: ""
  });

const navigate = useNavigate();
const handleCancel = () => {
  navigate("/participantes");
};
    
  const [form] = Form.useForm();
  useEffect(() => {
  if (!id) return; // evita ejecuciones si id no existe aún

  const fetchData = async () => {
    try {
      const response = await obtenerUsuario(id);
      console.log(response);

      if (response) {
        setUsuario(response);
        form.setFieldsValue({
          ...response,
          nacimiento: response.nacimiento ? dayjs(response.nacimiento) : null,
          pagado: response.pagado ? response.pagado : "0",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchData();
}, [id, form]);


  const onFinish = async (values) => {
  if (guardando) return;
  setGuardando(true);
  setErrorGuardar("");
  try {
    const datosEnviar = {
      ...values,
      nacimiento: values.nacimiento
        ? values.nacimiento.format("YYYY-MM-DD")
        : null,
        id:usuario.id 
    };
    console.log("Datos a enviar:", datosEnviar);
    const resultado = await actualizarUsuario(datosEnviar);
    if (resultado?.success !== false && !resultado?.error && (resultado?.id || resultado?.success === true)) {
        modal.success({
          title: "Participante actualizado",
          content: obtenerMensaje(resultado, "¡Los datos se actualizaron correctamente!"),
          okText: "Aceptar",
          onOk: () => navigate("/participantes"),
        });
    } else {
        setErrorGuardar(obtenerMensaje(resultado, "No se pudieron actualizar los datos. Intenta nuevamente."));
    }
    } catch (error) {
        console.error("Error al guardar:", error);
        setErrorGuardar(obtenerMensaje(error.response?.data,
          error.response
            ? "No se pudieron guardar los cambios. Intenta nuevamente."
            : "No se pudo conectar con el servidor. Revisa tu conexión e intenta nuevamente."
        ));
    } finally {
        setGuardando(false);
    }
};

  return (
    <div
        style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f5f5f5"
    }}
    >
      

      {contextHolder}
      <Card title="" style={{ maxWidth: 850, width: "100%" }}>
        <h2>Editar Participante</h2>
        {errorGuardar && (
          <Alert
            type="error"
            showIcon
            title={errorGuardar}
            role="alert"
            style={{ marginBottom: 16 }}
          />
        )}
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        htmlType="submit"
        initialValues={{
            nacimiento: usuario.nacimiento ? dayjs(usuario.nacimiento) : null
        }}
      >
        <Form.Item
          label="Nombre"
          name="nombre"
          rules={[
            { required: true, message: "El nombre es obligatorio" }
          ]}
        >
          <Input placeholder="Nombre" />
        </Form.Item>

        <Form.Item
          label="Apellidos"
          name="apellidos"
          rules={[
            { required: true, message: "Los apellidos son obligatorios" }
          ]}
        >
        <Input placeholder="Apellidos" />
        </Form.Item>

        <Form.Item>
        
        <Form.Item
            label="Talla"
            name="talla"
            rules={[
                { required: true, message: "La talla es obligatoria" }
            ]}
        >

        <Select placeholder="Selecciona una talla">
            <Option value="Ninguna">Ninguna</Option>
            <Option value="Extrachica">Extrachica</Option>
            <Option value="Chica">Chica</Option>
            <Option value="Mediana">Mediana</Option>
            <Option value="Grande">Grande</Option>
            <Option value="Extragrande">Extragrande</Option>
        </Select>
        </Form.Item>

        <Form.Item
            label="Categoria"
            name="categoria"
            rules={[
                { required: true, message: "La categoria es obligatoria" }
            ]}
        >
        <Select placeholder="Selecciona una Categoría">
            <Option value="Juvenil">Juvenil (19 años o menos)</Option>
            <Option value="Libre">Libre (20-39 años)</Option>
            <Option value="Master">Máster (40-49 años)</Option>
            <Option value="Veteranos">Veteranos (50-59 años)</Option>
            <Option value="Veteranosplus">Veteranos Plus (60 en adelante)</Option>
            <Option value="MEDICOVeteranosfemenil">Médicos Femenil (Hasta 44 años)</Option>
            <Option value="MEDICOVeteranosvaronil">Médicos Varonil (Hasta 49 años)</Option>
            <Option value="MEDICOVeteranosvaronilplus">Médicos Varonil (50 años en adelante)</Option>
            <Option value="MEDICOVeteranosfemenilplus">Médicos Femenil (45 años en adelante)</Option>
        </Select>
        </Form.Item>

        <Form.Item
            label="Fecha de nacimiento"
            name="nacimiento"
            rules={[{ required: true, message: "La fecha es obligatoria" }]}
            >
            <DatePicker
                style={{ width: "100%" }}
                format="DD/MM/YYYY"
            />
        </Form.Item>
        <Form.Item
          label="Télefono"
          name="telefono"
          rules={[
            { required: true, message: "El Télefono es obligatorio" }
          ]}
        >
        <Input placeholder="Télefono" />
        </Form.Item>
          <Form.Item
          label="Correo"
          name="email"
          rules={[
            { required: true, message: "El correo es obligatorio" },
            { type: "email", message: "Ingresa un correo válido" }
         ]}
        >
        <Input placeholder="Correo" />
        </Form.Item>
        <Form.Item
            label="Sexo"
            name="sexo"
            rules={[
                { required: true, message: "Selecciona un Sexo" }
            ]}
        >

        <Select placeholder="Selecciona un sexo">
            <Option value="Hombre">Hombre</Option>
            <Option value="Mujer">Mujer</Option>
        </Select>
        </Form.Item>    

        <Form.Item
          label="Número de corredor"
          name="numero"
        >
          <Input placeholder="Número de corredor" />
        </Form.Item>

        <Button
        type="primary"
        
        htmlType="submit"
        loading={guardando}
        style={{ marginRight: 10 }}
        >
        {guardando ? "Guardando..." : "Guardar"}
        </Button>

        <Button 
            onClick={handleCancel} 
            style={{
                backgroundColor: "#ff4d4f",
                borderColor: "#ff4d4f",
                color: "#fff"
            }}
        >
        Cancelar
        </Button>
        </Form.Item>
      </Form>
    </Card>
    </div>
  );
};

export default EditarUsuario;
